import { SWRConfig } from "swr";
import React, { ReactNode, useCallback } from "react";
import { I18nProvider } from "../i18n/I18nContext";
import { useShallowEqualSelector } from "../hooks/useShallowSelector";
import { appLanguageSelector } from "../reducers/AppReducer";
import { ApiProvider } from "../api/ApiContext";
import {
  refreshTokenSelector,
  setRefreshToken,
  setToken,
  tokenSelector,
} from "../reducers/AuthReducer";
import { useAuthContext } from "../api/auth/AuthContext";
import { useDispatch } from "react-redux";

interface Props {
  readonly children: ReactNode;
}

export function ProviderContainer({ children }: Props) {
  const { AuthApi, logout } = useAuthContext();
  const refresh_token = useShallowEqualSelector(refreshTokenSelector);
  const dispatch = useDispatch();
  const language = useShallowEqualSelector(appLanguageSelector);
  const token = useShallowEqualSelector(tokenSelector);
  const refresh = useShallowEqualSelector(refreshTokenSelector);
  const reGetToken = useCallback(() => {
    AuthApi.refreshAccessToken({ refresh_token: refresh_token })
      .then((res) => {
        if (res) {
          dispatch(setToken({ token: res.access_token }));
          dispatch(setRefreshToken({ refreshToken: res.refresh_token }));
        } else {
          // @ts-ignore
          return logout();
        }
      })
      .catch(() => {
        // @ts-ignore
        return logout();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, AuthApi, logout]);
  return (
    <I18nProvider data={{ language }}>
      <ApiProvider data={{ language, refresh, token, reGetToken, logout }}>
        <SWRConfig value={{ revalidateOnFocus: false }}>{children}</SWRConfig>;
      </ApiProvider>
    </I18nProvider>
  );
}
